import { render, staticRenderFns } from "./PageNotFound.htm?vue&type=template&id=40580e5c&scoped=true&external"
import script from "./PageNotFound.js?vue&type=script&lang=js&external"
export * from "./PageNotFound.js?vue&type=script&lang=js&external"
import style0 from "./PageNotFound.scss?vue&type=style&index=0&id=40580e5c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40580e5c",
  null
  
)

export default component.exports